import styled from "styled-components";

export const STFPanel = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;